import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';

const MapNode = ({ data }) => {
  return (
    <div className="map-node">
      <Handle type="target" position={Position.Top} />
      <div className="node-title">{data.title}</div>
      {data.mapUrl ? (
        <iframe
          title={data.title}
          src={data.mapUrl}
          className="map-frame"
          loading="lazy"
        />
      ) : (
        <div className="map-placeholder">Map Placeholder</div>
      )}
      <Handle type="source" position={Position.Bottom} />
    </div>
  );
};

export default memo(MapNode);
